<div class="doctors-wrapper" style="height: max-content;">
    @if(!isConsultant && false){
    <div class="top-cards-section">
        <div class="top-cards-title py-10 ms-30">
            Today's Activities Summaries
        </div>
        <div class="cards-wrapper">
            <div class="card">
                <div class="top">
                    <div class="title">
                        <div class="rounded-icon">
                            <mat-icon>ramp_right

                            </mat-icon>
                        </div>
                        <div class="words">Outpatients</div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="bottom-value">
                        10
                        <!-- <div class="title">
                            <div class="rounded-icon" style="visibility: hidden;">
                                <mat-icon>ramp_right

                                </mat-icon>
                            </div>
                            <div class="words">10</div>
                        </div> -->
                    </div>
                </div>
                <div class="igi-woroko">
                    <mat-icon>vaccines</mat-icon>
                </div>
            </div>

            <div class="card">
                <div class="top">
                    <div class="title">
                        <div class="rounded-icon">
                            <mat-icon>local_hotel

                            </mat-icon>
                        </div>
                        <div class="words">Inpatients</div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="bottom-value">
                        5
                        <!-- <div class="title">
                            <div class="rounded-icon" style="visibility: hidden;">
                                <mat-icon>ramp_right

                                </mat-icon>
                            </div>
                            <div class="words">10</div>
                        </div> -->
                    </div>
                </div>
                <div class="igi-woroko">
                    <mat-icon>vaccines</mat-icon>
                </div>
            </div>


            <div class="card">
                <div class="top">
                    <div class="title">
                        <div class="rounded-icon">
                            <mat-icon>video_call

                            </mat-icon>
                        </div>
                        <div class="words">Virtual Encounters</div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="bottom-value">
                        2
                        <!-- <div class="title">
                            <div class="rounded-icon" style="visibility: hidden;">
                                <mat-icon>ramp_right

                                </mat-icon>
                            </div>
                            <div class="words">10</div>
                        </div> -->
                    </div>
                </div>
                <div class="igi-woroko">
                    <mat-icon>vaccines</mat-icon>
                </div>
            </div>


            <div class="card">
                <div class="top">
                    <div class="title">
                        <div class="rounded-icon">
                            <mat-icon>masks

                            </mat-icon>
                        </div>
                        <div class="words">Surgeries</div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="bottom-value">
                        1
                        <!-- <div class="title">
                            <div class="rounded-icon" style="visibility: hidden;">
                                <mat-icon>ramp_right

                                </mat-icon>
                            </div>
                            <div class="words">10</div>
                        </div> -->
                    </div>
                </div>
                <div class="igi-woroko">
                    <mat-icon>vaccines</mat-icon>
                </div>
            </div>
        </div>
    </div>
    }
    <div class="my-20 next-appointments">
        <div class="next-appointments-title">
            Next 3 Appointments
        </div>
        <div class="scrollable-container">
            <div class="cards-wrapper">
                @for(appointment of (nextAppointments$ | async) || []; track appointment.appointmentId) {
                <div class="card">
                    <div class="top btw">
                        <div class="left">
                            <div class="title">
                                <div class="rounded-icon">
                                    <mat-icon>event</mat-icon>
                                </div>

                                <div class="words">
                                    @if(appointment.patientReference){
                                    <div class="name" [appReferenceDisplay]="appointment.patientReference" [instantFetchAndReplace]="true">
                                        {{ appointment.patientName }}
                                    </div>
                                    } @else {
                                    <div class="name">
                                        {{ appointment.patientName }}
                                    </div>
                                    }
                                    <div class="type">
                                        {{ appointment.appointmentType }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <mat-divider></mat-divider>
                    <div class="bottom mb-10">
                        <div class="bottom-value ">
                            <div class="time">
                                <div class="rounded-icon">
                                    <mat-icon>schedule</mat-icon>
                                </div>
                                <div class="time">
                                    {{ appointment.start | date:'mediumDate' }} · {{ appointment.start | date:'shortTime' }} - {{ appointment.end | date:'shortTime' }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                } @empty {
                <div class="subtitle-text-color-2">No upcoming appointments.</div>
                }
            </div>
        </div>
    </div>

    <div class="my-20 next-appointments">
        <div class="next-appointments-title">
            Next 3 Tasks
        </div>
        <div class="scrollable-container">
            <div class="cards-wrapper">
                @for(task of (nextTasks$ | async) || []; track task.taskId) {
                <div class="card">
                    <div class="top btw">
                        <div class="left">
                            <div class="title">
                                <div class="rounded-icon">
                                    <mat-icon>task_alt</mat-icon>
                                </div>

                                <div class="words">
                                    <div class="name">
                                        {{ task.title }}
                                    </div>
                                    @if(task.patientReference){
                                    <div class="type" [appReferenceDisplay]="task.patientReference" [instantFetchAndReplace]="true">
                                        {{ task.patientReference }}
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <mat-divider></mat-divider>
                    <div class="bottom mb-10">
                        <div class="bottom-value ">
                            <div class="time">
                                <div class="rounded-icon">
                                    <mat-icon>schedule</mat-icon>
                                </div>
                                <div class="time">
                                    {{ task.start | date:'short' }}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                } @empty {
                <div class="subtitle-text-color-2">No open tasks.</div>
                }
            </div>
        </div>
    </div>

    <div class="todays-appointments my-30 ms-30 me-30">
        <div class="title mb-30">

            <span>Today's Appointments</span>
        </div>

        <app-appointment-ui>

        </app-appointment-ui>

    </div>

</div>
